import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { ContentTagPerformanceParams, getContentTagPerformance } from '~/services/ExperiencesService';

import { experiencesQueryKeys } from './experiencesQueryKeys';

export function useGetContentTagPerformance(params: ContentTagPerformanceParams) {
  return useQuery({
    queryKey: experiencesQueryKeys.contentTagPerformance(params),
    queryFn: () => getContentTagPerformance(params),
    placeholderData: keepPreviousData,
  });
}
